"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ThemeProvider;
exports.useTheme = exports.themes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _GlobalStyle = _interopRequireDefault(require("../GlobalStyle"));

var _dark = _interopRequireDefault(require("../dark.js"));

var _light = _interopRequireDefault(require("../light.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var themes = {
  LIGHT: 'light',
  DARK: 'dark',
  PREFERRED: 'preferred'
};
exports.themes = themes;

function getTheme(requestedTheme) {
  var _window;

  switch (requestedTheme) {
    case themes.LIGHT:
      return _light["default"];

    case themes.DARK:
      return _dark["default"];

    default:
      if (process.env.NODE_ENV !== 'production') {
        console.warn("Warning: Unrecognised '".concat(requestedTheme, "' theme requested. Defaulting to preferred OS theme."));
      }

    // eslint-disable-next-line no-fallthrough

    case themes.PREFERRED:
      return ((_window = window) === null || _window === void 0 ? void 0 : _window.matchMedia('(prefers-color-scheme: dark)').matches) ? _dark["default"] : _light["default"];
  }
}

var useTheme = function useTheme() {
  return _react["default"].useContext(_styledComponents.ThemeContext);
};
/**
 *
 * ### Higher order provider component

This provider component can be used to wrap child components so that it can apply the Blue Prism theming. Is usually one of your top-most components but can be used anywhere in the node tree to apply different theming styles.

If no theme is provided, it will adjust to the theme preferred by users OS.
 */


exports.useTheme = useTheme;

var _ref2 = /*#__PURE__*/_react["default"].createElement(_GlobalStyle["default"], null);

function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? themes.PREFERRED : _ref$theme;

  var _React$useState = _react["default"].useState(getTheme(theme)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      themeTokens = _React$useState2[0],
      setThemeTokens = _React$useState2[1];

  _react["default"].useEffect(function () {
    setThemeTokens(getTheme(theme));
  }, [theme]);

  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: themeTokens
  }, _ref2, children);
}